import { Component, EventEmitter, Output,Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Api } from '../../services/api';
import { AuthService } from '../../services/auth-service';

@Component({
  selector: 'app-slot-confirmation',
  standalone: false,
  templateUrl: './slot-confirmation.html',
  styleUrls: ['./slot-confirmation.scss']
})
export class SlotConfirmation implements OnInit{
@Output() submit = new EventEmitter<any>();
  @Input() bookSlotInfo: any;
  @Input() modulename:any;

  sessionName: any = '';
  userObj: any;
  slotTime: any = '';
  sessionId: any = '';
  lectureID: any = '';
  oldsessionId:any;
  bookingid:any;

  allTeacher: any[] = [];
  alreadyBooked: any[] = [];

  flag: boolean = false;
  bookingType: 'individual' | 'group' = 'individual';

  totalAvailableSeats: number = 0;
  selectAll: boolean = false;

  constructor(private apiservice: Api, public authService: AuthService,private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    console.log("bookSlotInfo",this.bookSlotInfo)
    const userString = this.authService.getUser();

  if (userString) {
    this.userObj = typeof userString === 'string'
      ? JSON.parse(userString)
      : userString;

   console.log("userObj",this.userObj.searchBy) 
  }
    console.log("this.userObj.userType",this.userObj.userType)
    if (this.userObj.userType === 'PRINCIPAL') {
      this.flag = true;
    }

    this.slotTime = this.bookSlotInfo.slotDate;
    this.sessionName = this.bookSlotInfo.name;
    this.totalAvailableSeats = this.bookSlotInfo.availableSeats;
    this.sessionId = this.bookSlotInfo.sessionid;
    this.lectureID = this.bookSlotInfo.lectureID;

    this.loadTeachersForPrincipal();
    this.loadTeacherIndividual();
    this.loadTeacherUserGoogle();
  }

  // =========================
  // LOAD TEACHERS PRINCIPAL
  // =========================

  loadTeachersForPrincipal() {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
     const hostUrl = localStorage.getItem('hostUrl');
     console.log("hostUrl",hostUrl)

    if (this.userObj.userType === 'PRINCIPAL' && this.bookingType === 'group') {
      let userTypeTemp = ""
      if(this.userObj.searchBy === "schoolId"){
        userTypeTemp = "COORDINATOR";
      }
      else{
        userTypeTemp = "PRINCIPAL";
      }
      this.apiservice
        .getTeacherByPrinciple(
          this.userObj.schoolId,
          this.bookSlotInfo.sessionid,
          
          userTypeTemp,
          'TEACHER',
          'ASSTTEACHER',
           hostUrl,
           this.bookSlotInfo.lectureID
        )
        .subscribe({
          next: (response: any) => {

            if (response?.status === 200) {

              this.allTeacher = response.data.map((teacher: any) => ({
                ...teacher,
                selected: teacher.isBooked === 1
              }));

              this.alreadyBooked = response.data.filter(
                (teacher: any) => teacher.isBooked === 1
              );

            }
          },
          error: (err) => console.error(err)
        });
    }
    if (this.userObj.userType === 'PRINCIPAL' && this.bookingType === 'individual') {
       console.log("hostUrl",hostUrl)
      let userTypeTemp = ""
      if(this.userObj.searchBy === "schoolId"){
        userTypeTemp = "COORDINATOR";
      }
      else{
        userTypeTemp = "PRINCIPAL";
      }
      this.apiservice
        .getTeacherByPrinciple(
          this.userObj.schoolId,
          this.bookSlotInfo.sessionid,
          userTypeTemp
         ,
          '',
          '',
          hostUrl,
          this.bookSlotInfo.lectureID
        )
        .subscribe({
          next: (response: any) => {

            if (response?.status === 200) {

              this.allTeacher = response.data.map((teacher: any) => ({
                ...teacher,
                selected: teacher.isBooked === 1
              }));

              this.alreadyBooked = response.data.filter(
                (teacher: any) => teacher.isBooked === 1
              );

            }
          },
          error: (err) => console.error(err)
        });
    }
  }

  // =========================
  // TEACHER LOGIN
  // =========================

  loadTeacherIndividual() {
    const hostUrl = localStorage.getItem('hostUrl');
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (this.userObj.userType === 'TEACHER') {

      this.apiservice
        .getTeacherByIndividual(
          this.userObj.schoolId,
          this.bookSlotInfo.sessionid,
          this.userObj.userId,
          '',
          hostUrl
        )
        .subscribe({
          next: (response: any) => {

            if (response?.status === 200) {

              this.allTeacher = response.data.map((teacher: any) => ({
                ...teacher,
                selected: teacher.isBooked === 1
              }));

              this.alreadyBooked = response.data.filter(
                (teacher: any) => teacher.isBooked === 1
              );

            }
          },
          error: (err) => console.error(err)
        });
    }
  }

  // =========================
  // GOOGLE USER LOGIN
  // =========================

  loadTeacherUserGoogle() {
    const hostUrl = localStorage.getItem('hostUrl');
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (user?.data?.userType?.trim() === 'USER') {

      this.apiservice
        .getTeacherByIndividual(
          user?.data?.schoolId,
          this.bookSlotInfo.sessionid,
          user?.data?.trainingUserId,
          '',
          hostUrl
        )
        .subscribe({
          next: (response: any) => {

            if (response?.status === 200) {

              this.allTeacher = response.data.map((teacher: any) => ({
                ...teacher,
                selected: teacher.isBooked === 1
              }));

              this.alreadyBooked = response.data.filter(
                (teacher: any) => teacher.isBooked === 1
              );

            }
          },
          error: (err) => console.error(err)
        });
    }
  }

  // =========================
  // COUNT SELECTED
  // =========================

  get selectedTeachersCount(): number {

    if (this.bookingType === 'group') {
      return this.allTeacher.some(t => t.selected && t.isBooked !== 1) ? 1 : 0;
    }

    return this.allTeacher.filter(
      t => t.selected && t.isBooked !== 1
    ).length;
  }

  // =========================
  // SELECT ALL
  // =========================

  toggleSelectAll(isChecked: boolean) {

    if (!isChecked) {

      this.allTeacher.forEach(t => {
        if (t.isBooked !== 1) t.selected = false;
      });

      this.selectAll = false;
      return;
    }

    if (this.bookingType === 'group') {

      this.allTeacher.forEach(t => {
        if (t.isBooked !== 1) t.selected = true;
      });

      this.selectAll = true;
      return;
    }

    const remainingSeats = this.totalAvailableSeats;

    const availableTeachers = this.allTeacher.filter(
      t => t.isBooked !== 1
    );

    if (availableTeachers.length > remainingSeats) {

      this.apiservice.displayToast(
        `Only ${remainingSeats} seats remaining`,
        500
      );

      this.selectAll = false;
      return;
    }

    availableTeachers.forEach(t => t.selected = true);

    this.selectAll = true;
  }

  // =========================
  // SINGLE SELECT
  // =========================

  onTeacherChange(teacher: any, isChecked: boolean) {

    if (teacher.isBooked === 1) return;

    if (this.bookingType === 'group') {
      teacher.selected = isChecked;
      return;
    }

    const remainingSeats = this.totalAvailableSeats;

    const selectedCount = this.allTeacher.filter(
      t => t.selected && t !== teacher && t.isBooked !== 1
    ).length;

    if (isChecked && selectedCount >= remainingSeats) {

      this.apiservice.displayToast(
        `Only ${remainingSeats} seats remaining`,
        500
      );

      teacher.selected = false;
      return;
    }

    teacher.selected = isChecked;
  }

  // =========================
  // DISABLE CHECKBOX
  // =========================

  isTeacherDisabled(teacher: any): boolean {

    if (teacher.isBooked === 1) return true;

    if (teacher.selected) return false;

    const remainingSeats = this.totalAvailableSeats;

    return this.selectedTeachersCount >= remainingSeats;
  }

  // =========================
  // SUBMIT BOOKING
  // =========================

  submitSelection() {

  //Get full selected teacher objects
  const selectedTeachers = this.allTeacher.filter(t => t.selected);

  // Booked IDs set
  const bookedUserIds = new Set(
    this.alreadyBooked.map((t: any) => t.userId)
  );

  // Filter objects
  const filteredUsers = selectedTeachers.filter(
    (user: any) => !bookedUserIds.has(user.userId)
  );

  // Validation
  if (filteredUsers.length === 0) {
    this.apiservice.displayToast(
      "This slot is already booked.",
      500
    );
    return;
  }
  
  //Prepare only required fields
  const formattedData = filteredUsers.map((u: any) => ({
    userId: u.userId,
    fullName: u.fullName,
    bookingid: u.bookingId,
    phoneNumber: u.phoneNumber,
    email: u.email,
    userType: u.userType,
    schoolId: u.schoolId
  }));
  console.log("formattedData",formattedData)
  // Payload
  let payload: any = {

    
    // lectureId: Number(this.bookSlotInfo.lectureID),
    // IDs (still useful for backend)
    userIds: filteredUsers.map((u: any) => u.userId),

    // Only required fields
    data: formattedData
  };
  let mobileNumbers = formattedData
  .map((u: any) => u.phoneNumber)
  .filter(num => !!num);
  if (mobileNumbers.length === 0 && this.userObj?.userType === 'TEACHER') {
  mobileNumbers = [this.userObj.phoneNumber];
}

let Name = formattedData
  .map((u: any) => u.fullName)
  .filter(num => !!num);
  if (Name.length === 0 && this.userObj?.userType === 'TEACHER') {
  Name = [this.userObj.fullName];
}

let BookingId = formattedData
  .map((u: any) => u.bookingid)
  .filter(num => !!num);
  if (BookingId.length === 0 && this.userObj?.userType === 'TEACHER') {
  BookingId = [];
}
  // Extra condition
  if (this.userObj?.userType?.trim() === 'PRINCIPAL') {
    payload.bookingType = this.bookingType;
  }
  if (this.userObj?.userType?.trim() === 'PRINCIPAL') {
    if(BookingId.length !== 0){
      payload.bookingId = BookingId;
    }
    else{
      payload.bookingId = [];
  }
    }
  if(this.userObj?.userType?.trim() === 'TEACHER') {
      if(BookingId.length !== 0){
      payload.bookingId = BookingId;
    }
    else{
      payload.bookingId = [];
  }
  }
  if(this.userObj?.userType?.trim() === 'PRINCIPAL' && this.bookingType === 'group') {
        payload.sessionId = Number(this.sessionId)
        payload.lectureId = Number(this.bookSlotInfo.lectureID)
  }
  if(this.userObj?.userType?.trim() === 'TEACHER') {
         payload.sessionId = Number(this.sessionId)
  }
  if(this.userObj?.userType?.trim() === 'PRINCIPAL' && this.bookingType === 'individual') {
        // payload.lectureId = Number(this.bookSlotInfo.lectureID)
        payload.sessionId = Number(this.sessionId)
  }
  // if (this.bookSlotInfo.oldsessionID){
  //   payload.oldSessionId = Number(this.bookSlotInfo.oldsessionID)
  // }
  // if(this.bookSlotInfo.lectureID && this.bookingType !=='individual'){
  //   payload.lectureID = Number(this.bookSlotInfo.lectureID);
  // }
  console.log("Final Payload", payload);

  // API Call
  this.apiservice.saveBookedslot(payload).subscribe({

    next: (result: any) => {

      if (result?.status === 200) {
        this.apiservice.displayToast('Congratulations! Your slot has been booked successfully.', 200);
         this.apiservice.emitBookingSuccess(true);
         this.sendmessage(mobileNumbers,Name);
        this.cdr.detectChanges();
      } else {
        this.apiservice.displayToast('Booking failed. Please try again.', 500);
      }

    },

    error: () => {
      this.apiservice.displayToast('Booking failed. Please try again.', 500);
    }

  });
}

  // =========================
  // BOOKING TYPE
  // =========================

  selectBookingType(type: 'individual' | 'group') {

    this.bookingType = type;

    this.loadTeachersForPrincipal();
  }

  bookflag(flag: any): boolean {
  return !!flag; 
}
formatTo12Hour(time: string) {
  if (!time) return '';

  time = time.toString().trim();

  // Remove existing AM/PM if present
  time = time.replace(/(AM|PM)/i, '').trim();

  let [hour, minute] = time.split(':');

  let h = parseInt(hour);
  const ampm = h >= 12 ? 'PM' : 'AM';

  // Convert to 12-hour format
  h = h % 12 || 12;

  return `${h.toString().padStart(2, '0')}:${minute} ${ampm}`;
}
formatDate(date: string) {
  if (!date) return '';

  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
}
sendmessage(mobilenumber:any[],Name:any[]){
  

  let payload = {
    numbers: mobilenumber,
    timeSlot: this.formatTo12Hour(this.slotTime), 
    name: Name,
    // module: this.bookSlotInfo.modulename,
    // topic: this.sessionName,
    date: this.formatDate(this.bookSlotInfo.date)
  };

  console.log("payload:", payload);

  this.apiservice.sendmessage(payload).subscribe({
    next: (res: any) => {
      console.log('Message sent', res);
    },
    error: (err) => {
      console.error('API Error', err);
    }
  });
}
}